import utils from '../utils'
import moment from 'moment'
import { createInvoiceSummaryByPayer, addItemInfo, addMobileInfo } from './common'

export function createKBankDCTTxt(invoices) {
  const summaryByPayer = createInvoiceSummaryByPayer(invoices)
  let data = ''
  let seqNo = 1

  for (let summary of summaryByPayer) {
    data += addPayerInfo(summary)
    for (let vendor of summary.vendors) {
      data += addVendorInfo(vendor)
      for (let inv of vendor.invoices) {
        data += addItemInfo(inv, seqNo)
        seqNo++
      }
      data += addMobileInfo(vendor)
    }
  }

  return data
}

function addPayerInfo (summary) {
  let data = ''
  
  // ---- LINE 1 ----
  // ลำดับ	ชื่อ Field ธนาคาร	ความหมาย	จำนวน Characters
  // 1	H			1
  data += 'H'
  // 2	DCT	ช่องทางการจ่ายชำระที่ทางธนาคารกำหนด		3
  data += 'DCT'
  // 3	Batch Ref	หมายเลขอ้างอิงแบตที่ทำรายการ		16
  data += utils.padNumber('', 16),
  // 4	000000			6
  data += utils.padNumber(0, 6),
  // 5	 Spacebar 	ช่องว่าง		14
  data += utils.space(14)
  // 6	Debit Account	หมายเลขบัญชีตัดเงิน		10
  data += utils.padNumber(summary.payerBankAccount, 10),
  // 7	 Spacebar 	ช่องว่าง		1
  data += utils.space(1)
  // 8	Total Debit Amount	จำนวนเงินรวมทั้งหมดของการจ่าย		18
  data += utils.padDecimalWithoutDot(summary.invoiceTotalNetAmount, 18),
  // 9	 Spacebar 	ช่องว่าง		1
  data += utils.space(1)
  // 10	Date	วันที่รายการมีผล	รูปแบบวันที่ YYMMDD	6
  // TODO: not sure what to use
  // use current date as default
  data += utils.padText(moment().tz("Asia/Bangkok").format("YYMMDD"), 6)
  // 11	 Spacebar  	ช่องว่าง		25
  data += utils.space(25)
  // 12	Company Name	ชื่อบริษัท		50
  data += utils.padText(summary.payerName, 50)
  // 13	Effective Date	วันที่รายการมีผล	รูปแบบวันที่ YYMMDD	6
  // TODO: not sure what to use
  // use current date as default
  data += utils.padText(moment().tz("Asia/Bangkok").format("YYMMDD"), 6)
  // 14	Total Credit Item	จำนวนรายการรวมทั้งหมดของการจ่าย		18
  data += utils.padNumber(summary.vendors.length, 18),
  // 15	Bank Fee Charge	การเรียกเก็บค่าธรรมเนียม	"N : Payer หักจากผู้ชำระเงิน
  // Y : Beneficiary หักจากผู้รับเงิน"	1
  // TODO: Not sure when to use Y / N
  data += 'N'
  // 16	 Spacebar  	ช่องว่าง		5
  data += utils.space(5)
  // 17	Enter	จบข้อมูลในบรรทัด		
  data += '\n'

  return data
}

function addVendorInfo (summary) {
  let data = ''

  // ---- LINE 2 ----
  // ลำดับ	ชื่อ Field ธนาคาร	ความหมาย	ข้อจำกัด	จำนวน Characters
  // 1	D			1
  data += 'D'
  // 2	ลำดับ Vendor			6
  data += utils.padNumber(summary.no, 6) // ลำดับ Vendor
  // 3	 Spacebar	ช่องว่าง		14
  data += utils.space(14)
  // 4	Account Number	เลขที่บัญชีคู่ค้า		10
  data += utils.padNumber(summary.payeeBankAccount, 10)
  // 5	 Spacebar 	ช่องว่าง		1
  data += utils.space(1)
  // 6	Amount	จำนวนเงินที่โอน		15
  data += utils.padDecimalWithoutDot(summary.invoiceTotalNetAmount, 15)
  // 7	 Spacebar 	ช่องว่าง		1
  data += utils.space(1)
  // 8	Date	วันที่รายการมีผล	รูปแบบวันที่ YYMMDD	6
  // TODO: not sure what to use
  // use current date as default
  data += utils.padText(moment().tz("Asia/Bangkok").format("YYMMDD"), 6)
  // 9	 Spacebar 	ช่องว่าง		25
  data += utils.space(25)
  // 10	Vendor Name	ชื่อคู่ค้า		50
  data += utils.padText(summary.payeeName, 50)
  // 11	Effective Date	วันที่รายการมีผล	รูปแบบวันที่ YYMMDD	6
  // TODO: not sure what to use as an Date
  // use current date as default
  data += utils.padText(moment().tz("Asia/Bangkok").format("YYMMDD"), 6)
  // 12	จำนวน Rate e-WHT	"Y1 : 001
  // Y2 : 002
  // Y3 : 003"	เช่น 3 rate ให้แสดงเป็น 003	3
  data += utils.padNumber(summary.eWhtRateCount, 3)
  // 13	Bene Ref	หมายเลขอ้างอิงแบตที่ทำรายการ		16
  data += utils.padText(summary.payeeReference, 16)
  // 14	 Spacebar 	ช่องว่าง		51
  data += utils.space(51)
  // 15	Fax / Email		"ต้องเปิดบริการกับธนาคารก่อน
  // - ถ้าใช้ Email ให้แสดง E
  // - ถ้าใช้ Fax ให้แสดง F"	1
  data += utils.padText('', 1)
  // 16	Advice Fax 	เบอร์ Fax คู่ค้า (จำเป็นต้องใส่กรณีที่มี Credit Advice ผ่านทาง Fax)	"- กรณีใช้ Fax ให้แสดงเบอร์ Fax
  // - กรณีใช้ Email ให้แสดงเป็นค่าว่าง"	9
  data += utils.padNumber(summary.payeeFax, 9)
  // 17	Spacebar	ช่องว่าง		41
  data += utils.space(41)
  // 18	AdviceEmail	Email คู่ค้า (จำเป็นต้องใส่กรณีที่มี Credit Advice ผ่านทาง Email)		50
  data += utils.padText(summary.payeeEmail, 50)
  // 19	Tax Amt Bef VAT	จำนวนเงินก่อนคิดภาษีมูลค่าเพิ่ม	"- ยอดรวมต่อ Vendor
  // - ยอดเงิน 1,000 ให้แสดงเป็น 0000001000.00"	13
  data += utils.padDecimal(summary.invoiceBaseAmount, 13)
  // 20	Tax Deducted	จำนวนเงินภาษีหัก ณ ที่จ่าย	"- ยอดรวมต่อ Vendor
  // - ยอดเงิน 1,000 ให้แสดงเป็น 0000001000.01"	13
  data += utils.padDecimal(summary.whtAmount, 13)
  // 21	Tax Amt After VAT	จำนวนเงินรวมภาษีมูลค่าเพิ่ม	"- ยอดรวมต่อ Vendor
  // - ยอดเงิน 1,000 ให้แสดงเป็น 0000001000.02"	13
  data += utils.padDecimal(summary.invoiceTotalNetAmount, 13)
  // 22	 Spacebar 	ช่องว่าง		10
  data += utils.space(10)
  // 23	Personal ID/Tax ID	เลขประจำตัวผูเสียภาษี/เลขประจำตัวบัตรประชาชน		13
  data += utils.padText(summary.payeeTaxID, 13)
  // 24	Vendor Address 1	ที่อยู่คู่ค้า		30
  // 25	Vendor Address 2	ที่อยู่คู่ค้า		30
  // 26	Vendor Address 3	ที่อยู่คู่ค้า		30
  // 27	Vendor Address 4	ที่อยู่คู่ค้า		30
  // TODO: split address?
  data += utils.padText(summary.payeeAddress, 120) // Vendor Address 1-4 (30 each)
  // 28	Enter	จบข้อมูลในบรรทัด		
  data += '\n'

  return data
}

export default {
  createKBankDCTTxt
}